import React from "react";

// Graphique de l'humeur des agents (réponse de GET /landing/moods) : partagé par la rubrique « Ambiance » et le bloc
// « Humeur des agents » des rubriques libres.
export default function MoodChart({moods}) {
    const maxCount = Math.max(...Object.values(moods.results), 1);

    return (
        <div className="chart">
            {moods.moods.map(m => {
                const count = moods.results[m.level] || 0;
                const heightPct = Math.round((count / maxCount) * 100);
                const isLow = m.level <= 2;
                return (
                    <div
                        key={m.level}
                        className={`bar${isLow ? " low" : ""}`}
                        style={{height: `${Math.max(heightPct, 5)}%`}}
                        title={`${m.label}: ${count} réponses`}
                    >
                        <span className="bar-label">{m.emoji}</span>
                    </div>
                );
            })}
        </div>
    );
}

// « 15 derniers jours » (fenêtre renvoyée par le serveur).
export const moodWindowLabel = (moods) => `${moods.window_days || 15} derniers jours`;

// Sous le seuil de confidentialité (répondants distincts) : aucun résultat n'est affiché.
export function BelowThresholdMessage({moods}) {
    return (
        <div className="below-threshold-msg">
            Pas assez de répondant·es sur les {moodWindowLabel(moods)} ({moods.respondents}/{moods.threshold}).
            <br/>Les résultats seront affichés dès que le seuil sera atteint.
        </div>
    );
}
